'use strict';

export default function isObjectNullified(anObject: Record<string, unknown>): boolean {
    return Object.values(anObject).every((value) => {
        return value === null;
    });
}
